import Customer from './customer';
import PaymentTerm from 'src/models/paymentTerm.js';
import { getIsoDateAsLocalDate } from 'src/utils/helpers.js';
import { cloneDeep } from 'lodash';
import i18n from 'src/i18n/index.js';

class AgreementDetails {
  constructor(params) {
    this.agreementId = params.agreementId;
    this.agreementParticipants = params.agreementParticipants.map(
      (participant) => new AgreementParticipant(participant),
    );
    this.collectivity = params.collectivity;
    this.contractCode = params.contractCode;
    this.totalAmount = params.totalAmount;
    this.paymentTerm = new PaymentTerm(params.paymentTerm);
    this.isPremiumPaidByCustomer = params.isPremiumPaidByCustomer;
    this.hasAgreementEnded = params.hasAgreementEnded;
    this.startDate = getIsoDateAsLocalDate(params.startDate);
    this.endDate = params.endDate ? getIsoDateAsLocalDate(params.endDate) : null;

    this.label = `${i18n.global.t('agreement-section.label.collectivity')} ${params.collectivity} (${i18n.global.t('agreement-section.label.contractCode')} ${params.contractCode})`;
    this.caption = `${i18n.global.t('agreement-section.caption.agreementId')} ${params.agreementId}`;

    this.editPolicyDenialReason = null;

    this.newlyInsuredPersonsInProgress = params.newlyInsuredPersonsInProgress.map(
      (newlyInsuredPersonInProgress) => new NewlyInsuredPersonInProgress(newlyInsuredPersonInProgress),
    );
    this.policyDetails = params.policyDetails;

    return this;
  }

  mapToBackendModel() {
    const model = cloneDeep(this);
    model.paymentTerm = this.paymentTerm.paymentTerm;
    model.agreementParticipants.forEach((participant) => {
      participant.customer.gender = participant.customer.gender.Gender.toString();
      participant.customer.role = participant.customer.role.Role.toString();
      if (participant.endDate === false) participant.endDate = null;
      participant.customer.customerNumber = participant.customer.customerNumber.toString();
    });

    return model;
  }

  updateEditPolicyDenialReason(currentUser, isMutable) {
    if (!this.isCustomerMainInsuredOnAgreement(currentUser.customerNumber))
      this.editPolicyDenialReason = i18n.global.t('policy-overview.edit-policy-not-possible-not-main-insured');
    else if (currentUser.isDefaulter)
      this.editPolicyDenialReason = i18n.global.t('policy-overview.edit-policy-not-possible-payment-deficit');
    else if (this.hasAgreementEnded)
      this.editPolicyDenialReason = i18n.global.t('policy-overview.ended-policy-not-editable');
    else if (!isMutable) this.editPolicyDenialReason = i18n.global.t('policy-overview.edit-policy-not-yet-possible');
    else this.editPolicyDenialReason = null;
    return this;
  }

  isCustomerMainInsuredOnAgreement(customerNumber) {
    return this.agreementParticipants.some(
      (ap) => ap.customer.role.Role === 'H' && ap.customer.customerNumber === customerNumber,
    );
  }
}

export class AgreementParticipant {
  constructor(params) {
    this.customer = new Customer(params.customer);
    this.policyNumber = params.policyNumber;
    this.startDate = getIsoDateAsLocalDate(params.startDate);
    this.endDate = params.endDate ? getIsoDateAsLocalDate(params.endDate) : false;
    this.productTypes = params.productTypes;
    return this;
  }
}

export class NewlyInsuredPersonInProgress {
  constructor(params) {
    this.initials = params.initials;
    this.fullLastName = params.fullLastName;
    this.birthDate = getIsoDateAsLocalDate(params.birthDate);
    this.role = params.role;
    return this;
  }
}

export { AgreementDetails as default };
